
import { Component, Prop, Vue } from "vue-property-decorator";
import { systemSrv } from "./../services/system";
import router from "@/router";
import { cacheSrv } from "./../services/cache";
import store from "./../store";
import axios from "axios";
import Datepicker from "vuejs-datepicker";

@Component({
  components: { Datepicker }
})
export default class ProfileForm extends Vue {
  memberAPIUrl = this.$store.getters.config.memberAPIUrl;

  interests = [
    {icon:"", active:true, title:"Food"},
    {icon:"", active:true, title:"Fashion"},
    {icon:"", active:false, title:"Beauty"},
    {icon:"", active:false, title:"Entertainment"},
    {icon:"", active:true, title:"XYZ"},
    {icon:"", active:true, title:"Food"},
    {icon:"", active:true, title:"Fashion"},
    {icon:"", active:false, title:"Beauty"},
    {icon:"", active:false, title:"Entertainment"},
    {icon:"", active:true, title:"XYZ"},
    {icon:"", active:true, title:"Food"},
    {icon:"", active:true, title:"Fashion"},
    {icon:"", active:false, title:"Beauty"},
    {icon:"", active:false, title:"Entertainment"},
    {icon:"", active:true, title:"XYZ"}
  ]
  profile = systemSrv.profile;
  
  processing = false;
  errorMessage = "";

  constructor() {
    super();
  }
  
}
